export interface VendorCategory {
  id: number;
  name: string;
  key: string;
}

export interface Vendor {
  id: number;
  name: string;
  company_name: string | null;
  email: string | null;
  phone: string | null;
  address1: string | null;
  address2: string | null;
  city: string | null;
  state: string | null;
  zipcode: string | null;
  country_code: string | null;
  description: string | null;
  notes: string | null;
  created_at: string;
  updated_at: string;
  vendor_category: VendorCategory | null;
}

export interface VendorCreatePayload {
  vendor_category_id: number;
  name: string;
  company_name?: string;
  email?: string;
  phone?: string;
  address1?: string;
  address2?: string;
  city?: string;
  state?: string;
  zipcode?: string;
  country_code?: string;
  description?: string;
  notes?: string;
}

export type VendorUpdatePayload = Partial<VendorCreatePayload>;

export interface VendorsPage {
  vendors: Vendor[];
  totalCount: number;
  totalPages: number;
  currentPage: number;
  perPage: number;
}

export interface VendorListParams {
  page?: number;
  perPage?: number;
  search?: string;
}

export const CUSTOMER_VENDORS_CHANGED_EVENT = 'customer-vendors:changed';

export interface CheckPaymentMethodContact {
  name: string;
  address_line1: string;
  address_line2?: string;
  city: string;
  province_or_state: string;
  postal_or_zip: string;
  country_code: string;
}

export interface CheckPaymentMethodData {
  bank_name: string;
  account_number: string;
  routing_number?: string;
  transit_number?: string;
  bank_country_code: string;
  signature_text: string;
  contact: CheckPaymentMethodContact;
}
